import { render, staticRenderFns } from "./TransferBancaria.vue?vue&type=template&id=74768402&scoped=true"
import script from "./TransferBancaria.vue?vue&type=script&lang=js"
export * from "./TransferBancaria.vue?vue&type=script&lang=js"
import style0 from "./TransferBancaria.vue?vue&type=style&index=0&id=74768402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74768402",
  null
  
)

export default component.exports